export default "__VITE_ASSET__90fa546b__"